import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Text, RedirectLink } from "./Text"
import Logo from "../../ressources/images/logo/logo-bil.svg"
import { query } from '../../utils/UrlUtils'
import './index.less';

class Validation extends Component {

    componentDidMount() {
        const { paymentInfo } = this.props;
        if (paymentInfo && paymentInfo.redirectUrl) {
            setTimeout(function () {
                window.location.href = paymentInfo.redirectUrl;
            }, 3000);
        }
    }

    render() {
        const { paymentInfo, paymentError, paymentSuccess } = this.props;
        return (
            <main id="main-validation-page">
                <div id="validation-content">
                    <div align="center">
                        <img src={Logo} alt="Logo BIL" />
                    </div>
                    <Text successMessage={paymentSuccess} errorMessage={paymentError} status={query("status")} />
                    {paymentInfo && paymentInfo.redirectUrl ?
                        <RedirectLink redirectUrl={paymentInfo.redirectUrl} />
                        : null
                    }
                </div>
            </main>
        );
    }
}

//REDUX
const mapStateToProps = (state) => ({
    paymentInfo: state.paymentInfoParam.paymentInfo,
    paymentError: state.paymentErrorParam.paymentError,
    paymentSuccess: state.paymentSuccessParam.paymentSuccess,
});

export default connect(mapStateToProps)(Validation);
